import React from 'react';

const FiltersSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 dark:via-white/10 to-transparent skeleton-wave" />
          <div className="h-10 bg-light-hover dark:bg-dark-hover rounded-lg" />
        </div>
      ))}
    </div>
  );
};

export default FiltersSkeleton;